import { FirmPublisherAppsView } from "@/components/features/settings/firm/FirmPublisherAppsView";
import {
  AppPageShell,
  CardContent,
  GlobalNotAuthorized,
  Typography,
} from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/apps/app-library")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();
  const canAccessApps = hasPagePermission(PAGE_PERMISSION_KEYS.appsAccess);

  if (!canAccessApps) {
    return <GlobalNotAuthorized />;
  }

  return (
    <AppPageShell surface="card" cardClassName="p-6">
      <CardContent className="space-y-6 p-0">
        <div className="space-y-1">
          <Typography color="primary" variant="pageHeading" tag="h1">
            App library
          </Typography>
          <Typography variant="subHeading">
            Discover and connect apps for your firm
          </Typography>
        </div>
        <FirmPublisherAppsView mode="library" />
      </CardContent>
    </AppPageShell>
  );
}
